"use client"

import { ImageMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ImageMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ImageMinusIcon = component(Icon)({ as: ImageMinus })
